<template>
  <div class="dod0">
    <div class="dod0_backtotop" v-on:click="onBackToTop" v-touchfeedback>
      <icon name="arrowTop" type="full" />
      <icon name="arrowTop" type="full" />
      <icon name="arrowTop" type="full" />
      <icon name="arrowTop" type="full" />
      <icon name="arrowTop" type="full" />
      <icon name="arrowTop" type="full" />
      <icon name="arrowTop" type="full" />

      <icon name="arrowTop" type="full" />
      <icon name="arrowTop" type="full" />
      <icon name="arrowTop" type="full" />
      <icon name="arrowTop" type="full" />
      <icon name="arrowTop" type="full" />
      <icon name="arrowTop" type="full" />
      <icon name="arrowTop" type="full" />

      <icon name="arrowTop" type="full" />
      <icon name="arrowTop" type="full" />
      <icon name="arrowTop" type="full" />
      <icon name="arrowTop" type="full" />
      <icon name="arrowTop" type="full" />
      <icon name="arrowTop" type="full" />
      <icon name="arrowTop" type="full" />

      <icon name="arrowTop" type="full" />
      <icon name="arrowTop" type="full" />
      <icon name="arrowTop" type="full" />
      <icon name="arrowTop" type="full" />
      <icon name="arrowTop" type="full" />
      <icon name="arrowTop" type="full" />
      <icon name="arrowTop" type="full" />

      <icon name="arrowTop" type="full" />
      <icon name="arrowTop" type="full" />
      <icon name="arrowTop" type="full" />
      <icon name="arrowTop" type="full" />
      <icon name="arrowTop" type="full" />
      <icon name="arrowTop" type="full" />
      <icon name="arrowTop" type="full" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Day0',

  data: () => ({
  }),

  methods: {
    onBackToTop() {
      this.$emit('backtotop')
    }
  }
}
</script>

<style scoped lang="scss">
.dod0 {
  @include FR_FULLSIZE;
  @include FR_FLEX_LAYOUT(center, center);
  overflow: hidden;
  text-align: center;
}

.dod0_backtotop {
  @include FR_FLEX_LAYOUT(center, center, wrap);
  margin: 0 auto;
  cursor: pointer;
  max-width: 70vmin;
  max-height: 70vmin;
  @include FR_MQ_MIN(M) {
    max-width: 80vmin;
    max-height: 80vmin;
  }
  &.is-touch {
    // ...
  }
}

.dod0_backtotop .svgicon {
  @include FR_WH((70vmin / 7 * 0.8), 'flex');
  margin: (70vmin / 7 * 0.1);
  @include FR_MQ_MIN(M) {
    @include FR_WH((80vmin / 7 * 0.8), 'flex');
    margin: (80vmin / 7 * 0.1);
  }
}
</style>
